var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "span",
    { staticClass: "timePicker" },
    [
      _c("h4", [_vm._v(_vm._s(_vm.label))]),
      _vm._v(" "),
      _c("h2", [
        _vm._v(_vm._s(_vm.localHours + ":" + _vm.pad(_vm.localMinutes))),
      ]),
      _vm._v(" "),
      _c("slider", {
        attrs: { label: "HR ", value: _vm.localHours, max: 23 },
        on: { "slider-change": _vm.hoursChanged },
      }),
      _vm._v(" "),
      _c("slider", {
        attrs: { label: "MIN", value: _vm.localMinutes, max: 59 },
        on: { "slider-change": _vm.minutesChanged },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }